import { render, staticRenderFns } from "./IdentityForm.vue?vue&type=template&id=05854ace&scoped=true&"
import script from "./IdentityForm.vue?vue&type=script&lang=js&"
export * from "./IdentityForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05854ace",
  null
  
)

export default component.exports